import { render, staticRenderFns } from "./InvestMatDetails.vue?vue&type=template&id=060e1485&scoped=true&"
import script from "./InvestMatDetails.vue?vue&type=script&lang=js&"
export * from "./InvestMatDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestMatDetails.vue?vue&type=style&index=0&id=060e1485&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e1485",
  null
  
)

export default component.exports